


























import { Component, Vue, Prop } from "vue-property-decorator";
import NewFolderRequest from "../models/new-folder-request";

@Component({})
export default class NewFolderModal extends Vue {
  @Prop({ default: "" }) id!: string;
  @Prop({ default: () => new NewFolderRequest() }) form!: NewFolderRequest;

  updateName(name: string) {
    this.form.name = name;
    this.$emit("updateName", name);
  }

  ok() {
    this.$emit("ok", this.form);
    (this.$refs.modal as any).hide();
  }

  show() {
    this.$emit("show");
  }
}
